import {
  ApiUpdateProductQuantityFromMyWishlistRequestedAction,
  apiUpdateProductQuantityFromMyWishlistFailed,
  apiUpdateProductQuantityFromMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/updateProductQuantityFromMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import logger from '@spa/lib/logger';
import updateProductQuantityFromMyWishlistAction from '@spa/lib/actions/wishlists/updateProductQuantityFromMyWishlistAction';

function* updateProductQuantityFromMyWishlistApiSaga({
  payload: { actionId: requestedActionId, input, parentActionId }
}: ApiUpdateProductQuantityFromMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(
      updateProductQuantityFromMyWishlistAction,
      'updateProductQuantityFromMyWishlistAction',
      input
    );

    if (result.__typename === 'UpdateProductQuantityFromMyWishlistSucceededResult') {
      yield* put(
        apiUpdateProductQuantityFromMyWishlistSucceeded({
          input,
          parentActionId,
          requestedActionId
        })
      );
    } else {
      yield* put(
        apiUpdateProductQuantityFromMyWishlistFailed({
          error: result.error,
          parentActionId,
          requestedActionId
        })
      );
    }
  } catch (error) {
    logger.error(error, 'Error updating product quantity from my wishlist');

    yield* put(
      apiUpdateProductQuantityFromMyWishlistFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default updateProductQuantityFromMyWishlistApiSaga;
